import * as React from 'react';
import { MouseEventHandler } from 'react';
import { CustomDateRange } from '../../../../services/mini/analytics/customDateRange';
import ComboBox from '../../../components/ComboBox/ComboBox';

const predefinedDateRanges = [
    { name: 'Custom', key: CustomDateRange.Custom },
    { name: 'Today', key: CustomDateRange.Today },
    { name: 'Yesterday', key: CustomDateRange.Yesterday },
    { name: 'This week', key: CustomDateRange.ThisWeek },
    { name: 'This month', key: CustomDateRange.ThisMonth },
    { name: 'Last week', key: CustomDateRange.LastWeek },
    { name: 'Last month', key: CustomDateRange.LastMonth },
    { name: 'Last 7 days', key: CustomDateRange.Last7Days },
    { name: 'Last 30 days', key: CustomDateRange.Last30Days },
];

type PredefinedDateRangeComboboxProps = {
    value: string;
    className: string;
    onChange: MouseEventHandler<HTMLDivElement>;
}

export function PredefinedDateRangeCombobox({ value, onChange, className }: PredefinedDateRangeComboboxProps) {
    return <div className={className}>
        <ComboBox
            values={predefinedDateRanges}
            valueKey="key"
            valueName="name"
            selectedValueId={value}
            renderItem={(dateRangeItem) => {
                return <div>
                    {dateRangeItem.name}
                </div>;
            }}
            onValueSelect={(dateRangeItem) => {
                onChange(dateRangeItem.key);
            }}
        />
    </div>;
}